import React, { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { PropTypes } from 'prop-types';
import Redactor from '../../../redactor.min.js';
import Textarea from '../Textarea';
import '@general/scss/redactor.scss';

const WYSIWYG = ({ label, ...props }) => {
    const { name, required, charCount, initialValue } = props;
    const formikProps = useFormikContext();

    useEffect(() => {
        Redactor('.redactor', 'source.setCode', initialValue);
    }, [initialValue]);

    useEffect(() => {
        Redactor('.redactor', {
            buttons: ['bold', 'italic', 'underline', 'ol', 'ul'],
            callbacks: {
                blur(e) {
                    const html = this.api('module.source.getCode');
                    formikProps.setFieldValue(name, html);
                },
            },
        });
    });

    return (
        <>
            <Textarea label={label} name={name} required={required} charCount={charCount} className="redactor" />
        </>
    );
};

WYSIWYG.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    initialValue: PropTypes.string,
    charCount: PropTypes.number,
    required: PropTypes.bool,
};

export default WYSIWYG;
